export { default } from './RoomMainBlock';



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/index.js